export enum ErrorCode {
  THRESHOLD_LIMIT = 6900,
  AI_THRESHOLD_LIMIT = 4253,
}

export class ThresholdLimitError extends Error {
  code: number;

  constructor () {
    super('Threshold limit reached');
    this.name = 'ThresholdLimitError';
    this.code = ErrorCode.THRESHOLD_LIMIT;
  }
}

export class AiThresholdLimitError extends Error {
  code: number;

  constructor () {
    super('AI threshold limit reached');
    this.name = 'AiThresholdLimitError';
    this.code = ErrorCode.AI_THRESHOLD_LIMIT;
  }
}

export const isThresholdLimitError = (error: Error): error is ThresholdLimitError => {
  return error instanceof ThresholdLimitError || (error as any).code === ErrorCode.THRESHOLD_LIMIT;
};

export const isAiThresholdLimitError = (error: Error): error is AiThresholdLimitError => {
  return error instanceof AiThresholdLimitError || (error as any).code === ErrorCode.AI_THRESHOLD_LIMIT;
};

export const parseErrorMessage = (error: unknown): string => {
  if (error instanceof Error) {
    return error.message;
  }
  return String(error);
};
